/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShippingOrderAddressChange {
  address?: string;
  addressChangeId?: number;
  addressId?: number;
  city?: string;
  cityCode?: number;
  country?: string;
  countryCode?: number;
  dateCreated?: Date;
  neighborhood?: string;
  oldAddress?: string;
  oldAddressId?: number;
  oldCity?: string;
  oldCityCode?: number;
  oldCountry?: string;
  oldCountryCode?: number;
  oldNeighborhood?: string;
  oldPhone?: string;
  oldPostalCode?: string;
  oldRecipientName?: string;
  oldState?: string;
  oldStateCode?: number;
  oldStreet?: string;
  oldStreetExtension?: string;
  oldStreetNumber?: string;
  phone?: string;
  postalCode?: string;
  recipientName?: string;
  shippingOrderId?: number;
  state?: string;
  stateCode?: number;
  street?: string;
  streetExtension?: string;
  streetNumber?: string;
}
